import {
  AvailablePaymentOption,
  QuotesResponse,
} from "../../PaymentOptions/PaymentOptions";
import Cookies from "js-cookie";

import {
  getTradeInQuotes,
  TradeInQuotesResponse,
} from "../../../../client/getTradeInQuotes";

export interface BasketTradeInQuote {
  basketId: string;
  tradeInQuotes: Array<{
    tradeInQuoteId: string;
    deviceName: string;
    expiry: string;
    payment: AvailablePaymentOption;
  }>;
  errors: [];
}

export const getBasketQuotes = async (
  baseUrl: string,
): Promise<QuotesResponse[]> => {
  const basketId = Cookies.get("basket_id");

  if (!basketId) return [];

  const response: TradeInQuotesResponse = await getTradeInQuotes(baseUrl);

  if (response.quote) {
    const { tradeInQuotes } = response.quote as BasketTradeInQuote;
    if (tradeInQuotes) {
      return tradeInQuotes.map(({ tradeInQuoteId, ...rest }) => {
        return {
          id: tradeInQuoteId,
          ...rest,
        };
      });
    }
  }
  return [];
};
